import React from 'react';
import {Trans} from '@lingui/macro';
import {Box, Grid, Hidden, Paper, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import {useSelector} from 'react-redux';

const Headline = ({courseCount}) => {
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user.fullName);

  return (
    <Paper className={`bayerLighter-background ${classes.paper}`}>
      <Box height="10vh">
        <Typography variant="h5">
          <Trans>Bienvenido</Trans> {user}
        </Typography>

        <Hidden xsDown>
          <Grid container spacing={3}>
            <Grid item sm={4} xs={12} style={{display: 'flex'}}>
              <FiberManualRecord className="red-text" />
              <Typography variant="subtitle2" noWrap>
                <Trans>Not yet started</Trans>: {courseCount.notStarted}
              </Typography>
            </Grid>
            <Grid item sm={4} xs={12} style={{display: 'flex'}}>
              <FiberManualRecord className="yellow-text" />
              <Typography variant="subtitle2" noWrap>
                <Trans>In progress</Trans>: {courseCount.inProgress}
              </Typography>
            </Grid>
            <Grid item sm={4} xs={12} style={{display: 'flex'}}>
              <FiberManualRecord className="green-text" />
              <Typography variant="subtitle2" noWrap>
                <Trans>Finished</Trans>: {courseCount.finished}
              </Typography>
            </Grid>
          </Grid>
        </Hidden>
      </Box>
    </Paper>
  );
};

export default Headline;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    color: '#fafafa',
  },
}));
